// app/main/flights/flights-list/FlightsReservationListPage.tsx

import React, { useEffect, useState } from "react";
import PageHeader from "app/main/shared-components/page-header/PageHeader";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "app/store";
import { getReservationsFlight } from "../store/flights-list/get-reservations.slice";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import DateUtils from "../../../utils/DateUtils";
import CollapsibleTable from "../../shared-components/collapsible-table/CollapsibleTable";
import { useTranslation } from "react-i18next";
import TotalTurnoverModal from "./TotalTurnoverModal";
import FinancialReportsService, {
  FlightFinancialReport,
} from "app/services/financial-reports.services";

const FlightsReservationListPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const { params }: any = useRouteMatch();
  const { reservationsFlight, loading } = useSelector(
    (state: AppState) => state.flights.flightsList.reservationsFlight
  ) as any;

  const [reservations, seReservations] = useState(
    JSON.parse(JSON.stringify(reservationsFlight)) || []
  );

  const openQuickPanel = useSelector((state: AppState) => state.quickPanel);

  const flight = useSelector(
    (state: AppState) => state.flights.flight.flight
  ) as any;

  const { t } = useTranslation();

  const [turnoverOpen, setTurnoverOpen] = useState(false);
  const [turnoverLoading, setTurnoverLoading] = useState(false);
  const [turnoverData, setTurnoverData] =
    useState<FlightFinancialReport | null>(null);
  const [turnoverError, setTurnoverError] = useState<string | null>(null);

  useEffect(() => {
    dispatch(
      getReservationsFlight({
        id: params.id,
        onSuccess: (res: any) => {
          seReservations(res);
        },
      })
    );
  }, []);

  useEffect(() => {
    dispatch(
      getReservationsFlight({
        id: params.id,
        onSuccess: (res: any) => {
          seReservations(res);
        },
      })
    );
  }, [openQuickPanel]);

  useEffect(() => {
    if (loading) {
      dispatch(
        getReservationsFlight({
          id: params.id,
          onSuccess: (res: any) => {
            seReservations(res);
          },
        })
      );
    }
  }, [loading]);

  const title = flight
    ? `${t(
        "app.main.sidebar.schedules.desc",
        "List of reservations"
      )} (${flight.departureAirportCode} -> ${
        flight.arrivalAirportCode
      } - ${DateUtils.toHumanDate(
        DateUtils.convertDate(flight.dateOfDeparture)
      )} - ${flight.timeOfDeparture})`
    : t("app.main.sidebar.schedules.desc", "List of reservations");



  const handleOpenTurnover = async () => {
    if (!params?.id) return;

    setTurnoverOpen(true);
    setTurnoverLoading(true);
    setTurnoverError(null);

    try {
      const data = await FinancialReportsService.getFlightReport(params.id);
      setTurnoverData(data);
    } catch (e) {
      setTurnoverError(
        t(
          "app.flights.totalTurnover.error",
          "Could not load total turnover report for this flight."
        )
      );
    } finally {
      setTurnoverLoading(false);
    }
  };

  const handleCloseTurnover = () => {
    setTurnoverOpen(false);
    setTurnoverData(null);
    setTurnoverError(null);
  };


  return (
    <div>
     <PageHeader
      backButton={() => history.goBack()}
      title={title}
      desc={"Rezervimet.."}
      button={t("app.flights.totalTurnover.button", "Total turnover")}
      onClickButton={handleOpenTurnover}
    />


      <div style={{ marginTop: 10, padding: 10, marginBottom: 10 }}>
        {/* search/filter area if needed */}
      </div>

      <CollapsibleTable data={reservations} loading={loading} />

      <TotalTurnoverModal
      open={turnoverOpen}
      loading={turnoverLoading}
      data={turnoverData}
      error={turnoverError}
      onClose={handleCloseTurnover}
    />

    </div>
  );
};

export default FlightsReservationListPage;
